import gestureCssUrl from 'leaflet-gesture-handling/dist/leaflet-gesture-handling.min.css?url';
import gestureJsUrl from 'leaflet-gesture-handling/dist/leaflet-gesture-handling.min.js?url';

const MARKER_KEY = '__leafletGestureHandlingLoaded__';

let loadPromise: Promise<void> | null = null;

async function injectPlugin(): Promise<void> {
    const linkId = 'leaflet-gesture-handling-css-link';
    if (!document.getElementById(linkId)) {
        const link = document.createElement('link');
        link.id = linkId;
        link.rel = 'stylesheet';
        link.href = gestureCssUrl;
        document.head.appendChild(link);
    }

    await new Promise<void>((resolve, reject) => {
        const script = document.createElement('script');
        script.src = gestureJsUrl;
        script.onload = () => {
            (window as unknown as Record<string, boolean>)[MARKER_KEY] = true;
            resolve();
        };
        script.onerror = () => reject(new Error('Failed to load leaflet-gesture-handling'));
        document.head.appendChild(script);
    });
}

/**
 * leaflet-gesture-handling registers with global `window.L` (CDN Leaflet). Safe to await in parallel across maps.
 */
export function ensureLeafletGestureHandling(): Promise<void> {
    if (typeof window === 'undefined') return Promise.resolve();
    const w = window as unknown as Record<string, boolean>;
    if (!window.L || w[MARKER_KEY]) return Promise.resolve();

    loadPromise ??= injectPlugin()
        .catch((err) => {
            console.warn(err);
        })
        .finally(() => {
            loadPromise = null;
        });

    return loadPromise;
}
